export default __webpack_public_path__ + "8fb1aa5091ad1b262ff95b3ff94967a4.png";